import React from 'react';
import { motion } from 'framer-motion';
const fade = {
  hidden: {
    opacity: 0,
    y: 24
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.1,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
export function HeroSection() {
  return <section className="relative w-full h-screen overflow-hidden bg-primary" data-id="element-91" data-mp="23xed4gez5d7x">
      {/* Full-bleed render — the image leads */}
      <motion.div initial={{
      opacity: 0,
      scale: 1.08
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 1.6,
      ease: [0.16, 1, 0.3, 1]
    }} className="absolute inset-0" data-id="element-92" data-mp="2wj76y0ialhik">
        <img src="https://cdn.magicpatterns.com/uploads/o4UGbA4urx3abHHuALaY2Q/WhatsApp_Image_2026-10-03_at_16.17.39_(1).jpg" alt="Upper-level living space at 35 Campanilla with timber spiral staircase and floor-to-ceiling garden views" className="w-full h-full object-cover" data-id="element-93" data-mp="2rsh3istffoqi" />
      </motion.div>

      {/* Soft scrim only where text sits, so the image stays dominant */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-black/20 pointer-events-none" data-id="element-94" data-mp="2beyesq12s43w" />

      {/* Quiet caption-style title anchored to the bottom — image first */}
      <div className="absolute bottom-0 left-0 right-0 z-10 px-6 md:px-14 pb-24 md:pb-28" data-id="element-95" data-mp="2ked1dee4fuj4">
        <motion.div initial="hidden" animate="visible" variants={fade} className="max-w-7xl mx-auto text-center" data-id="element-96" data-mp="2z2q2sqvza5l0">
          <h1 className="font-heading text-white font-light leading-[1.05] tracking-tight text-3xl sm:text-4xl md:text-5xl" data-id="element-97" data-mp="2u6r68g0hxh9i">
            35 Campanilla Corner Agoho
          </h1>
        </motion.div>
      </div>

      {/* Scroll Indicator — centered so it never overlaps the caption text */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2" data-id="element-98" data-mp="1ds97q1rin1b6">
        <div className="w-[1px] h-12 bg-white/20 overflow-hidden" data-id="element-99" data-mp="3du8zwp3k82zi">
          <motion.div animate={{
          y: ['-100%', '100%']
        }} transition={{
          repeat: Infinity,
          duration: 1.5,
          ease: 'linear'
        }} className="w-full h-full bg-white" data-id="element-100" data-mp="3ipxt8aozknnd" />
        </div>
      </motion.div>
    </section>;
}